export const getDateTimeLocal = (date?: Date | string): string => {
  const baseDate = date ? new Date(date) : new Date();

  const offset = baseDate.getTimezoneOffset();
  const localDate = new Date(baseDate.getTime() - offset * 60 * 1000);

  return localDate.toISOString().slice(0, 16);
};
